import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '../lib/cn'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  children?: ReactNode
}

const variantClass: Record<NonNullable<ButtonProps['variant']>, string> = {
  primary: 'aug-btn--primary',
  secondary: 'aug-btn--secondary',
  ghost: 'aug-btn--ghost',
}

const sizeClass: Record<NonNullable<ButtonProps['size']>, string> = {
  sm: 'aug-btn--sm',
  md: 'aug-btn--md',
  lg: 'aug-btn--lg',
}

export function Button({ variant = 'primary', size = 'md', className, type = 'button', ...props }: ButtonProps) {
  return <button type={type} className={cn('aug-btn', variantClass[variant], sizeClass[size], className)} {...props} />
}
